// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-9624cf58] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.button-vue[data-v-9624cf58] {
  --button-size: var(--default-clickable-area);
  --button-inner-size: calc(var(--button-size) - 4px);
  --button-radius: var(--border-radius-element, calc(var(--button-size) / 2));
  --button-padding-default: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));
  --button-padding: var(--default-grid-baseline) var(--button-padding-default);
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
  border: 1px solid var(--color-primary-element-light-hover);
  border-bottom-width: 2px;
  border-radius: var(--button-radius);
  box-sizing: border-box;
  position: relative;
  width: fit-content;
  overflow: hidden;
  padding-block: 1px 0;
  padding-inline: var(--button-padding);
  min-height: var(--button-size);
  min-width: var(--button-size);
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: color, border-color, background-color;
  transition-duration: 0.1s;
  transition-timing-function: linear;
  cursor: pointer;
  font-size: var(--default-font-size);
  font-weight: bold;
}
.button-vue--size-small[data-v-9624cf58] {
  --button-size: var(--clickable-area-small, 24px);
  --button-radius: var(--border-radius);
}
.button-vue--size-large[data-v-9624cf58] {
  --button-size: var(--clickable-area-large, 48px);
}
.button-vue[data-v-9624cf58], .button-vue[data-v-9624cf58] * {
  cursor: pointer;
}
.button-vue[data-v-9624cf58]:focus {
  outline: none;
}
.button-vue[data-v-9624cf58]:disabled {
  cursor: default;
  opacity: 0.5;
  filter: saturate(0.7);
}
.button-vue[data-v-9624cf58]:disabled * {
  cursor: default;
}
.button-vue[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-primary-element-light-hover);
}
.button-vue[data-v-9624cf58]:active {
  background-color: var(--color-primary-element-light);
}
.button-vue__wrapper[data-v-9624cf58] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.button-vue--end .button-vue__wrapper[data-v-9624cf58] {
  justify-content: end;
}
.button-vue--start .button-vue__wrapper[data-v-9624cf58] {
  justify-content: start;
}
.button-vue--reverse .button-vue__wrapper[data-v-9624cf58] {
  flex-direction: row-reverse;
}
.button-vue--reverse.button-vue--icon-and-text[data-v-9624cf58] {
  --button-padding: var(--button-padding-default) var(--default-grid-baseline);
}
.button-vue__icon[data-v-9624cf58] {
  --default-clickable-area: var(--button-inner-size);
  height: var(--button-inner-size);
  width: var(--button-inner-size);
  min-height: var(--button-inner-size);
  min-width: var(--button-inner-size);
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-vue--size-small .button-vue__icon[data-v-9624cf58] > * {
  max-height: 16px;
  max-width: 16px;
}
.button-vue--size-small .button-vue__icon[data-v-9624cf58] svg {
  height: 16px;
  width: 16px;
}
.button-vue__text[data-v-9624cf58] {
  font-weight: bold;
  margin-bottom: 1px;
  padding: 2px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.button-vue--icon-only[data-v-9624cf58] {
  --button-padding: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));
  line-height: 1;
  width: var(--button-size) !important;
}
.button-vue--text-only[data-v-9624cf58] {
  --button-padding: var(--button-padding-default);
}
.button-vue--text-only .button-vue__text[data-v-9624cf58] {
  margin-inline: 4px;
}
.button-vue--wide[data-v-9624cf58] {
  width: 100%;
}
.button-vue[data-v-9624cf58]:focus-visible {
  outline: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 4px var(--color-main-background) !important;
}
.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-9624cf58] {
  outline: 2px solid var(--color-primary-element-text);
  border-radius: var(--border-radius-element, var(--border-radius));
  background-color: transparent;
}
.button-vue--vue-primary[data-v-9624cf58] {
  background-color: var(--color-primary-element);
  border-color: var(--color-primary-element-hover);
  color: var(--color-primary-element-text);
}
.button-vue--vue-primary[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-primary-element-hover);
}
.button-vue--vue-primary[data-v-9624cf58]:active {
  background-color: var(--color-primary-element);
}
.button-vue--vue-secondary[data-v-9624cf58] {
  background-color: var(--color-primary-element-light);
  border-color: var(--color-primary-element-light-hover);
  color: var(--color-primary-element-light-text);
}
.button-vue--vue-secondary[data-v-9624cf58]:hover:not(:disabled) {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light-hover);
}
.button-vue--tertiary[data-v-9624cf58], .button-vue--vue-tertiary[data-v-9624cf58] {
  background-color: transparent;
  border-color: transparent;
  color: var(--color-main-text);
}
.button-vue--tertiary[data-v-9624cf58]:hover:not(:disabled), .button-vue--vue-tertiary[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-background-hover);
}
.button-vue--vue-tertiary-no-background[data-v-9624cf58]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-9624cf58] {
  color: var(--color-primary-element-text);
}
.button-vue--vue-tertiary-on-primary[data-v-9624cf58]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-success[data-v-9624cf58] {
  background-color: var(--color-success);
  border-color: var(--color-success-hover);
  color: var(--color-success-text);
}
.button-vue--vue-success[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-success-hover);
}
.button-vue--vue-success[data-v-9624cf58]:active {
  background-color: var(--color-success);
}
.button-vue--vue-warning[data-v-9624cf58] {
  background-color: var(--color-warning);
  border-color: var(--color-warning-hover);
  color: var(--color-warning-text);
}
.button-vue--vue-warning[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-warning-hover);
}
.button-vue--vue-warning[data-v-9624cf58]:active {
  background-color: var(--color-warning);
}
.button-vue--vue-error[data-v-9624cf58] {
  background-color: var(--color-error);
  border-color: var(--color-error-hover);
  color: var(--color-error-text);
}
.button-vue--vue-error[data-v-9624cf58]:hover:not(:disabled) {
  background-color: var(--color-error-hover);
}
.button-vue--vue-error[data-v-9624cf58]:active {
  background-color: var(--color-error);
}
.button-vue--legacy[data-v-9624cf58] {
  --button-inner-size: var(--button-size);
  border: none;
}
.button-vue--legacy.button-vue--vue-error[data-v-9624cf58], .button-vue--legacy.button-vue--vue-success[data-v-9624cf58], .button-vue--legacy.button-vue--vue-warning[data-v-9624cf58] {
  color: white;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcButton-DCgUYOPt.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,mDAAmD;EACnD,2EAA2E;EAC3E,2HAA2H;EAC3H,4EAA4E;EAC5E,8CAA8C;EAC9C,oDAAoD;EACpD,0DAA0D;EAC1D,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;EAC1D,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,kDAAkD;EAClD,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mHAAmH;EACnH,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oDAAoD;EACpD,iEAAiE;EACjE,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,wCAAwC;AAC1C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,oDAAoD;EACpD,sDAAsD;EACtD,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,0DAA0D;AAC5D;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-9624cf58] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.button-vue[data-v-9624cf58] {\n  --button-size: var(--default-clickable-area);\n  --button-inner-size: calc(var(--button-size) - 4px);\n  --button-radius: var(--border-radius-element, calc(var(--button-size) / 2));\n  --button-padding-default: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));\n  --button-padding: var(--default-grid-baseline) var(--button-padding-default);\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n  border: 1px solid var(--color-primary-element-light-hover);\n  border-bottom-width: 2px;\n  border-radius: var(--button-radius);\n  box-sizing: border-box;\n  position: relative;\n  width: fit-content;\n  overflow: hidden;\n  padding-block: 1px 0;\n  padding-inline: var(--button-padding);\n  min-height: var(--button-size);\n  min-width: var(--button-size);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition-property: color, border-color, background-color;\n  transition-duration: 0.1s;\n  transition-timing-function: linear;\n  cursor: pointer;\n  font-size: var(--default-font-size);\n  font-weight: bold;\n}\n.button-vue--size-small[data-v-9624cf58] {\n  --button-size: var(--clickable-area-small, 24px);\n  --button-radius: var(--border-radius);\n}\n.button-vue--size-large[data-v-9624cf58] {\n  --button-size: var(--clickable-area-large, 48px);\n}\n.button-vue[data-v-9624cf58], .button-vue[data-v-9624cf58] * {\n  cursor: pointer;\n}\n.button-vue[data-v-9624cf58]:focus {\n  outline: none;\n}\n.button-vue[data-v-9624cf58]:disabled {\n  cursor: default;\n  opacity: 0.5;\n  filter: saturate(0.7);\n}\n.button-vue[data-v-9624cf58]:disabled * {\n  cursor: default;\n}\n.button-vue[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue[data-v-9624cf58]:active {\n  background-color: var(--color-primary-element-light);\n}\n.button-vue__wrapper[data-v-9624cf58] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.button-vue--end .button-vue__wrapper[data-v-9624cf58] {\n  justify-content: end;\n}\n.button-vue--start .button-vue__wrapper[data-v-9624cf58] {\n  justify-content: start;\n}\n.button-vue--reverse .button-vue__wrapper[data-v-9624cf58] {\n  flex-direction: row-reverse;\n}\n.button-vue--reverse.button-vue--icon-and-text[data-v-9624cf58] {\n  --button-padding: var(--button-padding-default) var(--default-grid-baseline);\n}\n.button-vue__icon[data-v-9624cf58] {\n  --default-clickable-area: var(--button-inner-size);\n  height: var(--button-inner-size);\n  width: var(--button-inner-size);\n  min-height: var(--button-inner-size);\n  min-width: var(--button-inner-size);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.button-vue--size-small .button-vue__icon[data-v-9624cf58] > * {\n  max-height: 16px;\n  max-width: 16px;\n}\n.button-vue--size-small .button-vue__icon[data-v-9624cf58] svg {\n  height: 16px;\n  width: 16px;\n}\n.button-vue__text[data-v-9624cf58] {\n  font-weight: bold;\n  margin-bottom: 1px;\n  padding: 2px 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.button-vue--icon-only[data-v-9624cf58] {\n  --button-padding: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));\n  line-height: 1;\n  width: var(--button-size) !important;\n}\n.button-vue--text-only[data-v-9624cf58] {\n  --button-padding: var(--button-padding-default);\n}\n.button-vue--text-only .button-vue__text[data-v-9624cf58] {\n  margin-inline: 4px;\n}\n.button-vue--wide[data-v-9624cf58] {\n  width: 100%;\n}\n.button-vue[data-v-9624cf58]:focus-visible {\n  outline: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 4px var(--color-main-background) !important;\n}\n.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-9624cf58] {\n  outline: 2px solid var(--color-primary-element-text);\n  border-radius: var(--border-radius-element, var(--border-radius));\n  background-color: transparent;\n}\n.button-vue--vue-primary[data-v-9624cf58] {\n  background-color: var(--color-primary-element);\n  border-color: var(--color-primary-element-hover);\n  color: var(--color-primary-element-text);\n}\n.button-vue--vue-primary[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-hover);\n}\n.button-vue--vue-primary[data-v-9624cf58]:active {\n  background-color: var(--color-primary-element);\n}\n.button-vue--vue-secondary[data-v-9624cf58] {\n  background-color: var(--color-primary-element-light);\n  border-color: var(--color-primary-element-light-hover);\n  color: var(--color-primary-element-light-text);\n}\n.button-vue--vue-secondary[data-v-9624cf58]:hover:not(:disabled) {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue--tertiary[data-v-9624cf58], .button-vue--vue-tertiary[data-v-9624cf58] {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--color-main-text);\n}\n.button-vue--tertiary[data-v-9624cf58]:hover:not(:disabled), .button-vue--vue-tertiary[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-background-hover);\n}\n.button-vue--vue-tertiary-no-background[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-9624cf58] {\n  color: var(--color-primary-element-text);\n}\n.button-vue--vue-tertiary-on-primary[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-success[data-v-9624cf58] {\n  background-color: var(--color-success);\n  border-color: var(--color-success-hover);\n  color: var(--color-success-text);\n}\n.button-vue--vue-success[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-success-hover);\n}\n.button-vue--vue-success[data-v-9624cf58]:active {\n  background-color: var(--color-success);\n}\n.button-vue--vue-warning[data-v-9624cf58] {\n  background-color: var(--color-warning);\n  border-color: var(--color-warning-hover);\n  color: var(--color-warning-text);\n}\n.button-vue--vue-warning[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-warning-hover);\n}\n.button-vue--vue-warning[data-v-9624cf58]:active {\n  background-color: var(--color-warning);\n}\n.button-vue--vue-error[data-v-9624cf58] {\n  background-color: var(--color-error);\n  border-color: var(--color-error-hover);\n  color: var(--color-error-text);\n}\n.button-vue--vue-error[data-v-9624cf58]:hover:not(:disabled) {\n  background-color: var(--color-error-hover);\n}\n.button-vue--vue-error[data-v-9624cf58]:active {\n  background-color: var(--color-error);\n}\n.button-vue--legacy[data-v-9624cf58] {\n  --button-inner-size: var(--button-size);\n  border: none;\n}\n.button-vue--legacy.button-vue--vue-error[data-v-9624cf58], .button-vue--legacy.button-vue--vue-success[data-v-9624cf58], .button-vue--legacy.button-vue--vue-warning[data-v-9624cf58] {\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
